/* Token reader — resolves a CSS variable to its computed string.
   Any component needing a colour string in JS (e.g. an SVG stroke)
   should call this rather than hardcoding a hex. The resolved value
   tracks dark-mode via the browser's live computed style. */
export function token(name: string): string {
  if (typeof window === 'undefined') return '';
  const v = getComputedStyle(document.documentElement).getPropertyValue(name);
  return v ? v.trim() : '';
}

/* tokenHex(name, mode) — read a token's computed value in an explicit
   theme. Mounts a detached element with data-theme, reads the resolved
   CSS variable, removes the element. Reference pages use this to render
   hex labels guaranteed not to drift from tokens.css. */
const _hexCache: Record<'light' | 'dark', Map<string, string>> = {
  light: new Map(),
  dark: new Map(),
};

export function tokenHex(name: string, mode: 'light' | 'dark' = 'light'): string {
  if (typeof document === 'undefined') return '';
  const cache = _hexCache[mode] ?? _hexCache.light;
  const cached = cache.get(name);
  if (cached !== undefined) return cached;
  const el = document.createElement('div');
  el.setAttribute('data-theme', mode === 'dark' ? 'dark' : 'light');
  el.style.position = 'absolute';
  el.style.visibility = 'hidden';
  el.style.pointerEvents = 'none';
  document.body.appendChild(el);
  const v = getComputedStyle(el).getPropertyValue(name);
  el.remove();
  const out = v ? v.trim() : '';
  cache.set(name, out);
  return out;
}

/* Class-name helper */
export type ClassNameInput = string | false | null | undefined | 0;
export function cx(...parts: ClassNameInput[]): string {
  return parts.filter(Boolean).join(' ');
}
